module.exports = __webpack_public_path__ + "img/xx.92d811c4.png";